/*=========================================================================================
  File Name: moduleChatGetters.js
  Description: Chat Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import contacts from '@/views/apps/chat/contacts'

export default {
  chatDataOfUser: (state) => (id) => {
    // return state.chats.filter(item => item.user_id == id)
    return state.chats[Object.keys(state.chats).find((key) => key === id)]
  },
  chatContacts: (state, getters) => {
    const chatContacts = state?.chatContacts?.filter((contact) =>
      contact.name.toLowerCase().includes(state.chatSearchQuery.toLowerCase())
    )

    chatContacts.sort((x, y) => {
      const timeX = getters.chatLastMessaged(x.user_id).timestamp
      const timeY = getters.chatLastMessaged(y.user_id).timestamp
      return new Date(timeY) - new Date(timeX)
    })

    return chatContacts.sort((x, y) => {
      const chatDataX = getters.chatDataOfUser(x.user_id)
      const chatDataY = getters.chatDataOfUser(y.user_id)
      if (chatDataX && chatDataY) return chatDataY.isPinned - chatDataX.isPinned
      else return 0
    })
  },
  contacts: (state) => state?.contacts,
  contact: (state) => (contactId) =>
    state?.contacts?.find((contact) => contact.user_id === contactId),
  chats: (state) => {
    // Return messages as an array for display
    return Array.isArray(state.chats)
      ? state.chats.sort((a, b) => a.timestamp - b.timestamp)
      : []
  },
  chatUser: (state, getters, rootState) => (id) =>
    state?.contacts?.find((contact) => contact.user_id === id) ||
    rootState.AppActiveUser,

  chatLastMessaged: (state, getters) => (id) => {
    if (getters.chatDataOfUser(id))
      return getters.chatDataOfUser(id).msg.slice(-1)[0]
    else return false
  },
  chatUnseenMessages: (state, getters) => (id) => {
    let unseenMsg = 0
    const chatData = getters.chatDataOfUser(id)
    if (chatData) {
      chatData.msg.map((msg) => {
        if (!msg.isSeen && !msg.isSent) unseenMsg++
      })
    }
    return unseenMsg
  }
}
